import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DS } from '../../ds';
const tabs = [{
  path: '/blog',
  label: 'Artículos'
}, {
  path: '/blog/qa',
  label: 'Preguntas & Respuestas'
}] as const;
export function BlogTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  return <div style={{
    padding: '0 24px',
    borderBottom: `1px solid ${DS.color.border}`,
    background: '#fff',
    position: 'sticky',
    top: '68px',
    zIndex: 50
  }} data-id="element-330" data-mp="mfm6y8ce24hy">
      <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      gap: '28px'
    }} data-id="element-331" data-mp="w5xnqvh68869">
        {tabs.map(tab => {
        const isActive = location.pathname === tab.path;
        return <button key={tab.path} type="button" onClick={() => navigate(tab.path)} aria-current={isActive ? 'page' : undefined} style={{
          padding: '18px 0',
          background: 'transparent',
          border: 'none',
          color: isActive ? DS.color.teal : DS.color.body,
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          cursor: 'pointer',
          borderBottom: isActive ? `3px solid ${DS.color.aqua}` : '3px solid transparent',
          transition: `color 0.25s ${DS.ease.smooth}, border-color 0.25s ${DS.ease.smooth}`
        }} data-id="element-332" data-mp="3bwjxjo1w9nqz">
              {tab.label}
            </button>;
      })}
      </div>
    </div>;
}